import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import t from '../../../lib/I18n';
import RewardPointsInstruction from '../../fares/details/RewardPointsInstruction';

function RewardPointsInformation({ paidOrder, className }) {
    const { totalRewardPoints, rewardPointUid } = paidOrder;

    if (!totalRewardPoints || !rewardPointUid) {
        return null;
    }

    return (
        <div className={cn('reward-points__order-history', className)}>
            <div className="reward-points__container__content">
                <p className="reward-points__order-history__highlight">
                    {t('rewardPoints.information.pointsAmount', { totalRewardPoints })}
                </p>
                <p>{t('rewardPoints.information.acknowledgment')}</p>
            </div>
            <RewardPointsInstruction
                rewardPointUid={rewardPointUid}
                listClassName="reward-points__order-history__list"
            />
        </div>
    );
}

RewardPointsInformation.propTypes = {
    paidOrder: PropTypes.object.isRequired,
    className: PropTypes.object,
};

export default RewardPointsInformation;



// WEBPACK FOOTER //
// ./src/components/account/orders/RewardPointsInformation.js